import { SimpleGrid, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import FeatureCard from "../../molecules/FeatureCard";

interface WhyVellisProps {
  title: string;
  description?: string;
  content: {
    title: string;
    description: string;
    image: string;
  }[];
}

const WhyVellis: React.FC<WhyVellisProps> = ({
  title,
  description,
  content,
}) => {
  return (
    <VStack
      gap={0}
      maxW="1280px"
      w="100%"
      mx="auto"
      px={{ base: 4, "2xl": 0 }}
      pt={{ base: 10, md: 20 }}
      pb={{ base: 8, md: 16 }}
    >
      <Text
        as="h2"
        fontSize="48px"
        className="light-text"
        lineHeight="100%"
        pb={5}
      >
        {title}
      </Text>
      <Text fontSize="16px" color="#6A7471" pb={10}>
        {description}
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={5} w="100%">
        {" "}
        {content.map((item, index) => {
          return (
            <FeatureCard
              titleFontSize="32px"
              key={index}
              title={item.title}
              description={item.description}
              image={item.image}
            />
          );
        })}
      </SimpleGrid>
    </VStack>
  );
};

export default WhyVellis;
